import { Key } from 'react';

import {
  AgentShift,
  AgentShiftWithoutItems,
  RequestPreview,
  RequestType,
  SupervisorRequestPreview,
} from '../../../graphql/components';

export const getRequestKey = ({ id, type }: RequestPreview | SupervisorRequestPreview) => `${id}+${type}`;

export const getShiftKey = ({ agent: { id }, dateRange: { from } }: AgentShift | AgentShiftWithoutItems) =>
  `${id}+${new Date(from).getTime()}`;

/**
 * a reverse function for 'getRequestKey' helper to extract type and id from generated key
 * @param key a string containing id and key, generated by 'getRequestKey' helper
 * @returns [id, type]
 */
export const extractRequestIdAndTypeFromKey = (key: Key) => {
  const [id, type] = (key as string).split('+');

  return [id, type] as [string, RequestType];
};
